
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {
  mobileRulesEl,
  mobileRules,
  priceRulesEl,
  identityIdRulesEl,
  checkPlateCode,
  mailRulesEl,
  mileageRulesEl
} from "@common/src/utils/verify";
import GeneralVehicleSelect from "@common/src/components/scope/vehicle-select/index.vue";
import AreaSelect from "@/components/scope/area-select.vue";
import CustomerFlagSelect from "@common/src/components/scope/flag-select/index.vue";
import t from "@common/src/i18n/t";
const customer = namespace("customer");
const base = namespace("base");
const app = namespace("app");
const common_app = namespace("common_app");
const user = namespace("user");

@Component({
  components: { AreaSelect, GeneralVehicleSelect, CustomerFlagSelect }
})
export default class CustomerEdit extends Vue {
  @customer.Action createCustomer;
  @customer.Action updateCustomer;
  @customer.Action saveCustomer;
  @customer.Action getCustomerDetail;
  @customer.Action updateVehicleOwner;
  @customer.Action getCustomerExpensesRecord;
  @customer.Action queryInsureList;
  @customer.Action addInsure;
  @base.Action getDictionaryList;
  @base.Action getVehicleInfoByVin;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @app.Mutation setPBPX;
  @user.State defaultPlateFirstLetter;
  @user.State defaultPlateProvince;
  @common_app.State country;
  get breadData() {
    return [
      { name: t("test.customer-information"), path: "/setting/customer" },
      {
        name:
          this.$route.name === "customerAdd"
            ? t("setting.add-the-customer")
            : this.isChangeOwner
            ? t("v210906.change-owner")
            : t("setting.edit-the-customer")
      }
    ];
  }
  // LFV2A21K363553763
  vehicleCode: any = "";
  showSelectVehicleMode: boolean = false;
  vehicleListByVin: any = [];
  customerFormData: any = {
    orderNo: "",
    vehicle: {
      plateCodePrev: t("setting.shanghai"),
      plateCodePost: "",
      plateCode: "",
      vinCode: "",
      vehicleCode: "",
      modelCode: "",
      price: "",
      engineCode: "",
      registerDate: "",
      inspectionExpireDate: "",
      insuranceExpireDate: "",
      insuranceCompany: "",
      lastMaintenanceMileage: "",
      nextMaintenanceMileage: "",
      nextMaintenanceDate: "",
      labelDescList: [] // 客户标签
    },
    customerName: "",
    customerCode: "",
    mobile: "",
    gender: "",
    customerId: "",
    birthday: "",
    source: "",
    area: [],
    address: "",
    type: "",
    companyName: "",
    settleMethod: "",
    memberFlag: 0,
    stateName: "",
    cityName: "",
    districtName: "",
    stateCode: "",
    cityCode: "",
    districtCode: "",
    vehicleCode: ""
  };
  showMobileUsedTips: boolean = false;
  options: any[] = [];
  customerSourceList: any[] = []; // 数据字典：用户来源list
  customerTypeList: any[] = []; // 数据字典：用户类型list
  settleMethodList: any[] = []; // 数据字典：结算方式list
  insuranceCompanyList: any[] = []; // 数据字典：保险公司list
  insuranceCompanyListCopy: any[] = []; // 数据字典：保险公司list
  showAreaSelect: boolean = false; //控制地区信息set完成后，显示组件
  defaultVehicleList: any[] = [];
  loadEnd: boolean = false;
  customerDataByMobile: any = {};
  customerFormRules = {
    "vehicle.plateCode": [{ required: true, validator: this.validatePlateCode, trigger: "blur" }],
    "vehicle.price": [{ validator: this.checkVehiclePrice, trigger: "blur" }],
    // "vehicle.modelCode": [{ required: true, message: t("test.select-car-model"), trigger: "blur" }],
    "vehicle.nextMaintenanceMileage": { validator: this.checkMileage, trigger: "blur" },
    mobile: { validator: this.validateMobile, trigger: "blur" },
    customerName: { validator: this.validateCustomerName, trigger: "blur" },
    customerId: { validator: this.validateIdentityId, trigger: "blur" },
    email: { validator: this.validateMail, trigger: "blur" }
  };
  checkMileage(rule, value, callback) {
    mileageRulesEl(value, callback, true);
  }
  companyListCopy: any[] = [];
  async addNewCompany() {
    (this.$refs["companySelect"] as any).blur();
    await this.addInsure({ insurerName: this.companySearchValue });
    // 添加新的保险公司;
    this.getCompanyList(() => {
      this.customerFormData.vehicle.insuranceCompany = this.companySearchValue;
    });
  }
  companySearchValue: string = ""; // 保险公司搜索keyword
  handleSearchCompany(val) {
    if (val) {
      this.companySearchValue = val;
      this.insuranceCompanyList = this.insuranceCompanyList.filter(item => {
        return item.insurerName.includes(val);
      });
    } else {
      this.insuranceCompanyList = this.insuranceCompanyListCopy;
    }
  }
  get isAdd() {
    return this.$route.name === "customerAdd";
  }
  get isChangeOwner() {
    return !!this.$route.query.changeOwner;
  }
  validateMail(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      mailRulesEl(value, callback);
    }
  }
  editPlateCode: any = "";
  validatePlateCode(rule, value, callback) {
    const checkResult = checkPlateCode(value, this.country);
    if (!checkResult.success) {
      return callback(new Error(checkResult.msg));
    }
    if (!this.isAdd) {
      // 编辑不查车牌是否存在
      return callback();
    }
    this.getCustomerDetail({
      plateCode: this.customerFormData.vehicle.plateCode
    }).then(data => {
      if (data.data) {
        callback(new Error(t("setting.license-plate-number-already-exists")));
      } else {
        callback();
      }
    });
  }
  handleVinBlur() {
    if (!this.customerFormData.vehicle.vinCode || this.country === "my") return;
    this.getVehicleInfoByVin({
      vinCode: this.customerFormData.vehicle.vinCode
    }).then(
      data => {
        if (data.data.length > 1) {
          this.showSelectVehicleMode = true;
          this.vehicleListByVin = data.data;
        } else if (data.data.length === 1) {
          this.handleSelectVehiclebyVin(data.data[0]);
        }
      },
      data => {
        this.$message.error(data.message);
      }
    );
  }
  handleLinkChangeOwner() {
    let { href } = this.$router.resolve(
      `/setting/customer-edit/${this.$route.params.id}?vehicleCode=${this.vehicleCode}&changeOwner=1`
    );
    window.open(href, "_blank");
  }
  handleSelectVehiclebyVin(vehicleData) {
    this.showSelectVehicleMode = false;
    this.customerFormData.vehicle.price = vehicleData.price;
    this.defaultVehicleList = this.vehicleDataFormat([vehicleData]);
    this.$nextTick(() => {
      (this.$refs["carForm"] as any).validateField("vehicle.modelCode", function (errmsg) {
        console.log(errmsg);
      });
    });
  }
  created() {
    this.setPBPX(52);
    this.init();
  }
  validateMobile(rule, value, callback) {
    if (this.isChangeOwner) {
      mobileRulesEl(value, callback);
    } else {
      if (!value) {
        callback();
      } else {
        mobileRulesEl(value, callback);
      }
    }
  }
  validateCustomerName(rule, value, callback) {
    if (this.isChangeOwner) {
      if (!this.customerFormData.customerName) {
        callback(new Error(t("v210831.please-enter-customer")));
      } else {
        callback();
      }
    } else {
      callback();
    }
  }
  validateIdentityId(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      identityIdRulesEl(value, callback);
    }
  }
  checkVehiclePrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  handleQueryCustomerExist() {
    if (
      (this.isAdd || this.isChangeOwner) &&
      this.customerFormData.mobile &&
      mobileRules(this.customerFormData.mobile).success
    ) {
      this.getCustomerDetail({
        mobile: this.customerFormData.mobile
      }).then(data => {
        if (data.data) {
          this.showMobileUsedTips = true;
          delete data.data.vehicleList;
          this.customerDataByMobile = data.data;
        } else {
          this.customerFormData.customerCode = "";
        }
      });
    }
  }
  clearCustomerInfo() {
    Object.keys(this.customerDataByMobile).forEach(item => {
      this.customerFormData[item] = "";
    });
    this.customerFormData.area = [];
    this.customerFormData.memberFlag = 0;
  }
  handleSetCustomerInfo() {
    this.showAreaSelect = false;
    Object.entries(this.customerDataByMobile).forEach(item => {
      this.customerFormData[item[0]] = item[1];
    });
    this.customerFormData.area = [
      this.customerDataByMobile.stateCode,
      this.customerDataByMobile.cityCode,
      this.customerDataByMobile.districtCode
    ];
    this.$nextTick(() => {
      this.showAreaSelect = true;
    });
    this.showMobileUsedTips = false;
  }
  handleOpoColse() {
    (this.$refs["carForm"] as any).validateField("vehicle.modelCode");
  }
  handleAreaChange() {
    this.$nextTick(() => {
      this.$nextTick(() => {
        const labels = (this.$refs["areaCascader"] as any).getLabels();
        this.customerFormData.stateName = labels[0];
        this.customerFormData.cityName = labels[1];
        this.customerFormData.districtName = labels[2];
      });
    });
    this.customerFormData.stateCode = this.customerFormData.area[0];
    this.customerFormData.cityCode = this.customerFormData.area[1];
    this.customerFormData.districtCode = this.customerFormData.area[2];
  }
  submitForm() {
    (this.$refs["carForm"] as any).validate(valid => {
      (this.$refs["customerForm"] as any).validate(valid2 => {
        if (valid && valid2) {
          this.btnStartLoading();
          if (this.isAdd) {
            this.addCustomer();
          } else {
            this.editCustomer();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    });
  }

  async init() {
    this.vehicleCode = this.$route.query.vehicleCode;
    const customerCode = this.$route.query.customerCode;
    this.getDictionaryList("customer_source").then(data => {
      this.customerSourceList = data;
    });
    this.getDictionaryList("customer_type").then(data => {
      this.customerTypeList = data;
    });
    this.getDictionaryList("settle_method").then(data => {
      this.settleMethodList = data;
    });
    this.getCompanyList();
    if (!this.isAdd) {
      const customerData = await this.getCustomerDetail({
        customerCode: this.$route.params.id,
        vehicleCode: this.vehicleCode
      });
      if (customerData?.data?.districtName) {
        customerData.data.area = [
          customerData.data.stateName,
          customerData.data.cityName,
          customerData.data.districtName
        ];
      }
      // 过滤车辆信息
      if (customerData.data.vehicleList.length) {
        // 如果有车辆信息
        customerData.data.vehicle = customerData.data.vehicleList.find(item => {
          return customerData.data.selectedVehicleCode === item.vehicleCode;
        });

        this.defaultVehicleList = this.vehicleDataFormat([customerData.data.vehicle]);
        this.customerFormData.vehicle.modelCode = this.defaultVehicleList[0].lastValue;
      } else {
        customerData.data.vehicle = {
          plateCodePrev: t("setting.shanghai"),
          plateCodePost: "",
          plateCode: "",
          vinCode: "",
          vehicleCode: "",
          modelCode: "",
          price: "",
          engineCode: "",
          registerDate: "",
          inspectionExpireDate: "",
          insuranceExpireDate: "",
          insuranceCompany: "",
          lastMaintenanceMileage: "",
          nextMaintenanceMileage: "",
          nextMaintenanceDate: ""
        };
      }
      this.customerFormData = customerData.data;
      this.customerFormData.orderNo = this.$route.query.fromOrderNo;
      this.editPlateCode = this.customerFormData.vehicle.plateCode || "";
      if (this.isChangeOwner) {
        let keyArr = Object.keys(this.customerFormData);
        keyArr.forEach(key => {
          if (key !== "vehicle") {
            this.customerFormData[key] = "";
          }
        });
        this.customerFormData["area"] = [];
        this.customerFormData["memberFlag"] = 0;
      }
    } else {
      if (this.defaultPlateFirstLetter) {
        this.customerFormData.vehicle.plateCode = this.defaultPlateProvince + this.defaultPlateFirstLetter;
      }
      if (customerCode) {
        const customerData = await this.getCustomerDetail({
          customerCode: customerCode
        });
        Object.keys(this.customerFormData).forEach(key => {
          const value = customerData.data[key];
          if (value) {
            this.customerFormData[key] = value;
          }
        });
        if (customerData.data.districtName) {
          this.customerFormData.area = [
            customerData.data.stateName,
            customerData.data.cityName,
            customerData.data.districtName
          ];
        }
      }
    }
    this.showAreaSelect = true;
  }
  getCompanyList(callback?) {
    this.queryInsureList({ pageNum: "1", pageSize: 5, insurerNmae: "" }).then(data => {
      console.log(data, "data");
      this.insuranceCompanyList = data.data.list;
      this.insuranceCompanyListCopy = data.data.list;
      callback && callback();
    });
  }
  vehicleDataFormat(data) {
    return data.map(item => ({
      lastValue: item.modelCode,
      name: item.brandName + " / " + item.seriesName + " / " + item.modelDesc,
      valueGroup: [item.brandCode, item.seriesName, item.modelCode]
    }));
  }

  async addCustomer() {
    this.saveCustomer(this.customerFormData)
      .then(() => {
        this.$message.success(t("base.success") as any);
        this.$router.push(`/setting/customer`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  async editCustomer() {
    if (this.isChangeOwner) {
      this.customerFormData.vehicleCode = this.customerFormData.vehicle.vehicleCode;
      this.updateVehicleOwner(this.customerFormData)
        .then(() => {
          this.$message.success(t("v210906.owner-replaced"));
          this.$router.push(`/setting/customer`);
        })
        .finally(() => {
          this.btnStopLoading();
        });
    } else {
      this.saveCustomer(this.customerFormData)
        .then(() => {
          this.$message.success(t("base.success") as any);
          this.$router.push(`/setting/customer`);
        })
        .finally(() => {
          this.btnStopLoading();
        });
    }
  }
  handleReInput() {
    this.customerFormData.mobile = "";
    this.showMobileUsedTips = false;
  }
}
